import{j as e}from"./chunk-GEPA7FLG.js";e();import{gql as n}from"@apollo/client";var l=n`
  query stakeDetails($groupId: String!, $rewardToken: String!) {
    stakeDetails(groupId: $groupId, rewardToken: $rewardToken) {
      farmingToken {
        ... on NftCollectionModel {
          collection
          decimals
          name
          balance
          ticker
          assets {
            svgUrl
            pngUrl
            __typename
          }
          __typename
        }
        ... on EsdtTokenModel {
          identifier
          decimals
          name
          balance
          ticker
          assets {
            svgUrl
            pngUrl
            __typename
          }
          __typename
        }
      }
      rewards {
        unlockSchedule {
          epoch
          percent
        }
        apr
        unbound
        areRewardsLocked
        farmAddress
        rewardToken {
          ... on NftCollectionModel {
            collection
            decimals
            name
            balance
            ticker
            assets {
              svgUrl
              pngUrl
              __typename
            }
            __typename
          }
          ... on EsdtTokenModel {
            identifier
            decimals
            name
            balance
            ticker
            assets {
              svgUrl
              pngUrl
              __typename
            }
            __typename
          }
        }
      }
    }
  }
`;export{l as a};
//# sourceMappingURL=chunk-DZRXD3XH.js.map
